export const STATE_READ = 'read';

export const STATE_EDIT = 'edit';

export const STATE_SAVE = 'save';

export const STATE_CREATE = 'create';
